module.exports = __webpack_public_path__ + "delivery.9bN45Lib.svg";